import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getUserInfoApi, getAuthInfoApi, getProjectListApi, changeProjectApi, getProjectBaseDataApi, getStreamerApi, getMobilisationPlanDataApi } from 'api'
import { BoundarySlice } from 'redux/reducers'
import { initPermissions } from 'utils'

const initialState = {
    projectBaseData: null,
    MobilisationPlanData: null, // 动迁计划
    StreamerData: null, // 托缆信息
    userInfo: null, // 用户信息
    authInfo: null, // 权限信息
    projectList: null, // 项目分页列表
    pageNum: 1, // 初始分页数
    outlineBorder: false, // 菜单栏简单模式切换
    hoverBorder: false, // 简单模式下的鼠标 hover 状态
    flag: false, // 浏览器菜单上下滚动状态
    onceFlag: false, // 浏览器菜单首次刷新无上滑状态
}

/* 获取 projectBase 数据 */
export const getProjectBaseDataAction = createAsyncThunk(
    'ProjectConfigSlice/getProjectBaseDataAction',
    async (projectId, thunkAPI) => {
        try {
            const { data } = await getProjectBaseDataApi(projectId)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 获取 动迁计划 数据 */
export const getMobilisationPlanDataAction = createAsyncThunk(
    'ProjectConfigSlice/getMobilisationPlanDataAction',
    async (projectId, thunkAPI) => {
        try {
            const { data } = await getMobilisationPlanDataApi(projectId)
            return data?.data?.[0]
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 获取 StreamerData 数据 */
export const getStreamerDataAction = createAsyncThunk(
    'ProjectConfigSlice/getStreamerDataAction',
    async (projectId, thunkAPI) => {
        try {
            const { data : { data } } = await getStreamerApi(projectId)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 请求用户信息 */
export const getUserInfoAction = createAsyncThunk('HeaderSlice/getUserInfoAction', async (_, thunkAPI) => {
    try {
        const { data } = await getUserInfoApi()
        const isLock = data?.project?.isLock
        if (isLock){
            const filteredArray = data?.permissions?.filter(item => {
                if (item === "setting:project:add" || item === "setting:project:remove") {
                    return true; // 包含这些权限
                }
                return !item.endsWith("edit") && !item.endsWith("remove") && !item.endsWith("write") && !item.endsWith("add")
            });
            data.permissions = filteredArray
        }
        return data
    } catch (error) {
        thunkAPI.dispatch(BoundarySlice.actions.addError(error))
    }
})

/* 请求用户权限信息 */
export const getAuthInfoAction = createAsyncThunk('HeaderSlice/getAuthInfoAction', async (_, thunkAPI) => {
    try {
        const { data } = await getAuthInfoApi()
        const isLock = data?.project?.isLock
        if (isLock) {
            const filteredArray = data?.permissions?.filter(item => {
                if (item === "setting:project:add" || item === "setting:project:remove" || item === "setting:project:edit") {
                    return true; // 包含这些权限
                }
                return !item.endsWith("edit") && !item.endsWith("remove") && !item.endsWith("write") && !item.endsWith("add")
            });
            data.permissions = filteredArray
        }
        // 初始化权限数据
        initPermissions(data?.permissions)
        return data
    } catch (error) {
        thunkAPI.dispatch(BoundarySlice.actions.addError(error))
    }
})

/* 请求项目分页列表 */
export const getProjectListAction = createAsyncThunk('HeaderSlice/getProjectListAction', async (params, thunkAPI) => {
    try {
        const { data } = await getProjectListApi(params)
        return data
    } catch (error) {
        thunkAPI.dispatch(BoundarySlice.actions.addError(error))
    }
})

/* 切换项目 */
export const changeProjectAction = createAsyncThunk('HeaderSlice/changeProjectAction', async (projectId, thunkAPI) => {
    try {
        const data = await changeProjectApi(projectId)
        return data
    } catch (error) {
        thunkAPI.dispatch(BoundarySlice.actions.addError(error))
    }
})

export const HeaderSlice = createSlice({
    name: 'HeaderSlice',
    initialState,
    reducers: {
        changepPageNum: (state, action) => {
            state.pageNum = action.payload
        },
        changepOutlineBorder: (state, action) => {
            state.outlineBorder = action.payload
        },
        changepHoverBorder: (state, action) => {
            state.hoverBorder = action.payload
        },
        changeMenuStyle: (state, action) => {
            state.flag = action.payload
        },
        changeOnceFlagStyle: (state, action) => {
            state.onceFlag = action.payload
        },
    },
    extraReducers: {
        /* 获取 projectBase 数据 */
        [getProjectBaseDataAction.fulfilled.type]: (state, action) => {
            state.projectBaseData = action.payload
        },

        /* 获取 动迁计划 数据 */
        [getMobilisationPlanDataAction.fulfilled.type]: (state, action) => {
            state.MobilisationPlanData = action.payload
        },

        /* 获取 Streamer 数据 */
        [getStreamerDataAction.fulfilled.type]: (state, action) => {
            state.StreamerData = action.payload
        },

        /* 请求用户信息 */
        [getUserInfoAction.fulfilled.type]: (state, action) => {
            state.userInfo = action.payload
        },

        /* 请求用户权限信息 */
        [getAuthInfoAction.fulfilled.type]: (state, action) => {
            state.userInfo = action.payload
        },

        /* 请求项目分页列表 */
        [getProjectListAction.fulfilled.type]: (state, action) => {
            state.projectList = action.payload
        },
    },
})
